import { useTheme } from "@emotion/react";
import {
  AccessTimeOutlined,
  Check,
  ExpandMore,
  KeyboardArrowDownOutlined,
  KeyboardArrowUpOutlined,
} from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Divider,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import useStyles from "./styles";
import dayjs from "dayjs";
import { Box } from "@mui/system";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect, useState } from "react";
export default function ButtonTime(params) {
  const {
    open = false,
    optionsTime = {},
    selectTime = 0,
    filterData = {},
    handleClick = () => {},
    anchorEl,
    handleClose = () => {},
    loading = false,
    startDate = null,
    endDate = null,
    setStartDate = () => {},
    setEndDate = () => {},
    handleStartChange = () => {},
    handleEndChange = () => {},
    handleAplicar = () => {},
    isValidRange = false,
    handleSelectTime = () => {},
    minDate = null,
    todayMaxDataTime = null,
    DateTime = <></>,
    formatDayjs = "DD/MM/YY HH:mm",
  } = params;
  const theme = useTheme();
  const styles = useStyles(theme);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [expanded, setExpanded] = useState("panel2");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (
      selectTime === null &&
      filterData?.initialDate &&
      filterData?.finalDate
    ) {
      setStartDate(dayjs(filterData?.initialDate));
      setEndDate(dayjs(filterData?.finalDate));
    }
  }, []);

  return (
    <>
      {windowWidth >= 1350 ? (
        <>
          {" "}
          <Button
            startIcon={<AccessTimeOutlined />}
            endIcon={
              open ? <KeyboardArrowUpOutlined /> : <KeyboardArrowDownOutlined />
            }
            sx={{
              color: theme.palette.text.main,
              borderColor: theme.palette.text.main,
              minWidth: "220px", // Mantém o tamanho mínimo que você definiu
              height: "40px",
              // Solução para não quebrar linha:
              whiteSpace: "nowrap",
              display: "flex",
              justifyContent: "space-between", // Espaça bem os ícones e o texto
            }}
            variant="outlined"
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
            disabled={loading}
          >
            {optionsTime[selectTime]?.label ||
              `De ${dayjs(filterData?.initialDate)?.format(
                `${formatDayjs}`,
              )} até ${dayjs(filterData?.finalDate)?.format(`${formatDayjs}`)}`}
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <Box sx={{ display: "flex", minWidth: "500px" }}>
              <Box sx={styles.containerSelectTime}>
                <Box sx={styles.containerTimeOption}>
                  <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                    Tempo absoluto
                  </Typography>
                </Box>
                <Box sx={styles.containerLocalizationProvider}>
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale="pt-br"
                  >
                    <Box sx={{ gap: 1.5, display: "flex" }}>
                      <DateTime
                        label=" De"
                        disabled={loading}
                        maxDate={endDate || dayjs()}
                        minDate={minDate} //dayjs().subtract(6, "month")
                        minDateTime={minDate}
                        maxDateTime={endDate || dayjs()} // Impede selecionar data futura
                        value={startDate}
                        onChange={handleStartChange}
                        slotProps={{
                          textField: { size: "small", fullWidth: true },
                          popper: {
                            placement: "right-start",
                            sx: {
                              "& .MuiPaper-root": {
                                bgcolor: "background.paper",
                                borderRadius: "8px",
                              },
                            },
                          },

                          day: {
                            sx: {
                              "&.Mui-selected": {
                                background:
                                  theme.palette.gradient.buttonSelected, // Cor de fundo da data selecionada
                                color: theme.palette.white.main, // Cor do texto da data selecionada
                              },
                              "&.Mui-selected:hover": {
                                background:
                                  theme.palette.gradient.buttonSelected, // Cor ao passar o mouse sobre a data selecionada
                              },
                            },
                          },
                        }}
                      />
                    </Box>

                    <Box sx={{ gap: 1, display: "flex" }}>
                      <DateTime
                        label="Até"
                        disabled={loading}
                        value={endDate}
                        maxDate={todayMaxDataTime ? todayMaxDataTime : dayjs()}
                        minDate={startDate}
                        minDateTime={startDate} // Impede selecionar data anterior ao "de"
                        maxDateTime={
                          todayMaxDataTime ? todayMaxDataTime : dayjs()
                        } // Exemplo: impedir datas futuras
                        onChange={handleEndChange}
                        slotProps={{
                          textField: { size: "small", fullWidth: true },
                          popper: {
                            placement: "right-start",
                          },
                          day: {
                            sx: {
                              "&.Mui-selected": {
                                background:
                                  theme.palette.gradient.buttonSelected,
                                color: theme.palette.white.main,
                              },
                              "&.Mui-selected:hover": {
                                background:
                                  theme.palette.gradient.buttonSelected,
                              },
                            },
                          },
                        }}
                      />
                    </Box>
                    <Box sx={styles.conatinerButton}>
                      <Button
                        onClick={handleAplicar}
                        size="small"
                        variant="contained"
                        disabled={!isValidRange}
                      >
                        Aplicar
                      </Button>
                    </Box>
                  </LocalizationProvider>
                </Box>
              </Box>
              <Divider orientation="vertical" flexItem component="li" />
              <Box sx={styles.containerSelectTime}>
                <Box sx={styles.containerTimeOption}>
                  <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                    Tempo relativo
                  </Typography>
                </Box>

                {Object.entries(optionsTime).map(([key, { label }]) => (
                  <MenuItem
                    key={key}
                    sx={styles.menuItem}
                    value={Number(key)}
                    onClick={() => {
                      handleSelectTime(Number(key));
                      handleClose();
                      setEndDate(null);
                      setStartDate(null);
                    }}
                  >
                    {label}
                    {selectTime === Number(key) && (
                      <ListItemIcon>
                        <Check
                          sx={{
                            color: theme.palette.primary.main,
                          }}
                        />
                      </ListItemIcon>
                    )}
                  </MenuItem>
                ))}
              </Box>
            </Box>
          </Menu>{" "}
        </>
      ) : (
        <Box sx={styles.containerAccordion}>
          <Accordion
            elevation={0}
            variant="outlined"
            disableGutters
            sx={{ width: "100%", margin: 0, mt: 2 }}
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="panel1"
              id="panel1"
            >
              <Typography component="span">Tempo absoluto</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box sx={styles.containerAutocomplete}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale="pt-br"
                >
                  <Box sx={{ gap: 1.5, display: "flex" }}>
                    <DateTime
                      label=" De"
                      disabled={loading}
                      maxDate={endDate || dayjs()}
                      minDate={minDate} //dayjs().subtract(6, "month")
                      minDateTime={minDate}
                      maxDateTime={endDate || dayjs()}
                      value={startDate}
                      onChange={handleStartChange}
                      slotProps={{
                        textField: { size: "small", fullWidth: true },
                        popper: {
                          placement: "bottom",
                          sx: {
                            "& .MuiPaper-root": {
                              bgcolor: "background.paper",
                              borderRadius: "8px",
                            },
                          },
                        },

                        day: {
                          sx: {
                            "&.Mui-selected": {
                              background: theme.palette.gradient.orangeMain, // Cor de fundo da data selecionada
                              color: theme.palette.white.main, // Cor do texto da data selecionada
                            },
                            "&.Mui-selected:hover": {
                              background: theme.palette.gradient.orangeMain, // Cor ao passar o mouse sobre a data selecionada
                            },
                          },
                        },
                      }}
                    />
                  </Box>

                  <Box sx={{ gap: 1, display: "flex" }}>
                    <DateTime
                      label="Até"
                      disabled={loading}
                      value={endDate}
                      maxDate={todayMaxDataTime ? todayMaxDataTime : dayjs()}
                      minDate={startDate}
                      minDateTime={startDate} // Impede selecionar data anterior ao "de"
                      maxDateTime={
                        todayMaxDataTime ? todayMaxDataTime : dayjs()
                      } // Exemplo: impedir datas futuras
                      onChange={handleEndChange}
                      slotProps={{
                        textField: { size: "small", fullWidth: true },
                        popper: {
                          placement: "bottom",
                        },
                        day: {
                          sx: {
                            "&.Mui-selected": {
                              background: theme.palette.gradient.orangeMain,
                              color: theme.palette.white.main,
                            },
                            "&.Mui-selected:hover": {
                              background: theme.palette.gradient.orangeMain,
                            },
                          },
                        },
                      }}
                    />
                  </Box>
                  <Box sx={styles.conatinerButton}>
                    <Button
                      onClick={handleAplicar}
                      size="small"
                      variant="contained"
                      disabled={!isValidRange}
                    >
                      Aplicar
                    </Button>
                  </Box>
                </LocalizationProvider>
              </Box>
            </AccordionDetails>
          </Accordion>

          <Accordion
            elevation={0}
            variant="outlined"
            disableGutters
            sx={{ width: "100%" }}
            expanded={expanded === "panel2"}
            onChange={handleChange("panel2")}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="panel2"
              id="panel2"
            >
              <Typography component="span">Tempo relativo</Typography>
            </AccordionSummary>
            <Divider />
            <AccordionDetails sx={styles.AccordionDetails}>
              {Object.entries(optionsTime).map(([key, { label }]) => (
                <MenuItem
                  key={key}
                  sx={styles.menuItem}
                  value={Number(key)}
                  onClick={() => handleSelectTime(Number(key))}
                >
                  {label}
                  {selectTime === Number(key) && (
                    <ListItemIcon>
                      <Check
                        sx={{
                          color: theme.palette.primary.main,
                        }}
                      />
                    </ListItemIcon>
                  )}
                </MenuItem>
              ))}
            </AccordionDetails>
          </Accordion>
        </Box>
      )}
    </>
  );
}
